module.exports = __webpack_public_path__ + "0fa3686e832b84510b3f7904c1daff22.png";